import React from "react";
import { LinkedResource } from "~/ProductDetails/ProductDetailPageResult";
import ResourceLink from "./ResourceLink";
interface Props {
  linkedResources: LinkedResource[];
  displaySubheader?: boolean;
}
const LinkedResources = ({
  linkedResources,
  displaySubheader = true
}: Props) => {
  return <>
      {linkedResources && linkedResources.length > 0 && <div className="resources">
          {displaySubheader && <p className="header-4">Resources</p>}
          <ul className="m-0">
            {linkedResources.map(resource => <ResourceLink link={resource.link} title={resource.title} key={resource.title} />)}
          </ul>
        </div>}
    </>;
};
export default LinkedResources;